export default __webpack_public_path__ + "static/media/hht1_home_img_EP19.bedb7c6f.png";